// Comparative Products JavaScript
document.addEventListener('DOMContentLoaded', function() {
  const comparativeProducts = document.querySelector('.comparative-products__container');
  
  if (!comparativeProducts) return;

  // Inicializar funcionalidades
  initAddToCartButtons();
  // initTableInteractions();
  initResponsiveTable();

  // Função para inicializar botões de adicionar ao carrinho
  function initAddToCartButtons() {
    const addToCartButtons = comparativeProducts.querySelectorAll('[data-js-product-add-to-cart]');
    
    addToCartButtons.forEach(button => {
      button.addEventListener('click', function(e) {
        e.preventDefault();
        
        const form = this.closest('form');
        
        // Adicionar classe de loading
        this.classList.add('button--loading');
        this.disabled = true;
        
        // Simular envio do formulário
        setTimeout(() => {
          // Aqui você pode adicionar lógica para enviar o produto ao carrinho
          // Por enquanto, vamos apenas remover o loading
          
          // Remover classe de loading
          this.classList.remove('button--loading');
          this.disabled = false;
        }, 1500);
      });
    });
  }

  // Função para inicializar interações da tabela
  function initTableInteractions() {
    const tableRows = comparativeProducts.querySelectorAll('.comparative-products__table-row');
    
    tableRows.forEach(row => {
      row.addEventListener('mouseenter', function() {
        this.style.backgroundColor = '#e8f4fd';
      });
      
      row.addEventListener('mouseleave', function() {
        this.style.backgroundColor = '';
      });
    });
  }

  // Função para tornar a tabela responsiva
  function initResponsiveTable() {
    const tableContainer = comparativeProducts.querySelector('.comparative-products__table-container');
    
    if (!tableContainer) return;

    // Adicionar scroll horizontal em telas pequenas
    function handleResize() {
      if (window.innerWidth < 768) {
        tableContainer.style.overflowX = 'auto';
      } else {
        tableContainer.style.overflowX = 'visible';
      }
    }

    // Executar na inicialização
    handleResize();
    
    // Executar no redimensionamento da janela
    window.addEventListener('resize', handleResize);
  }


  // Função para animar entrada dos elementos
  function animateElements() {
    const cards = comparativeProducts.querySelectorAll('.comparative-products__card');
    const table = comparativeProducts.querySelector('.comparative-products__table');
    
    // Animar cards
    cards.forEach((card, index) => {
      card.style.opacity = '0';
      card.style.transform = 'translateY(20px)';
      
      setTimeout(() => {
        card.style.transition = 'opacity 0.6s ease, transform 0.6s ease';
        card.style.opacity = '1';
        card.style.transform = 'translateY(0)';
      }, index * 200);
    });
    
    // Animar tabela
    if (table) {
      table.style.opacity = '0';
      table.style.transform = 'translateY(20px)';
      
      setTimeout(() => {
        table.style.transition = 'opacity 0.6s ease, transform 0.6s ease';
        table.style.opacity = '1';
        table.style.transform = 'translateY(0)';
      }, 400);
    }
  }

  // Executar animação
  animateElements();


  // Função para preencher estrelas baseada no data-rating
  function initStarRatings() {
    const starContainers = comparativeProducts.querySelectorAll('.comparative-products__stars[data-rating]');
    
    starContainers.forEach(container => {
      const rating = parseFloat(container.getAttribute('data-rating'));
      
      if (rating && rating > 0) {
        updateStarsFromRating(container, rating);
      }
    });
  }
  
  // Função para atualizar as estrelas baseada na avaliação
  function updateStarsFromRating(container, rating) {
    // Preservar contador de reviews antes de limpar
    const existingCount = container.querySelector('.comparative-products__review-count');
    const countText = existingCount ? existingCount.textContent : '';
    
    // Limpar conteúdo atual
    container.innerHTML = '';
    
    const fullStars = Math.floor(rating);
    const partialStar = rating - fullStars;
    
    // Estrelas cheias
    for (let i = 0; i < fullStars; i++) {
      const star = document.createElement('span');
      star.className = 'comparative-products__star comparative-products__star--filled';
      star.textContent = '★';
      container.appendChild(star);
    }
    
    // Estrela parcial
    if (partialStar > 0) {
      const partialStarElement = document.createElement('span');
      partialStarElement.className = 'comparative-products__star comparative-products__star--partial';
      partialStarElement.style.setProperty('--partial-width', `${partialStar * 100}%`);
      
      const bgStar = document.createElement('span');
      bgStar.className = 'comparative-products__star--partial-bg';
      bgStar.textContent = '★';
      
      const fgStar = document.createElement('span');
      fgStar.className = 'comparative-products__star--partial-fg';
      fgStar.textContent = '★';
      
      partialStarElement.appendChild(bgStar);
      partialStarElement.appendChild(fgStar);
      container.appendChild(partialStarElement);
    }
    
    // Estrelas vazias
    const emptyStars = 5 - fullStars - (partialStar > 0 ? 1 : 0);
    for (let i = 0; i < emptyStars; i++) {
      const star = document.createElement('span');
      star.className = 'comparative-products__star';
      star.textContent = '☆';
      container.appendChild(star);
    }
    
    // Adicionar contador após as estrelas
    if (countText) {
      const countSpan = document.createElement('span');
      countSpan.className = 'comparative-products__review-count';
      countSpan.textContent = countText;
      container.appendChild(countSpan);
    }
  }

  // Executar preenchimento das estrelas
  initStarRatings();
});

